"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsolateHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const isolate_header_style_1 = __importDefault(require("./isolate.header.style"));
class IsolateHeader extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => (jsx_runtime_1.jsx("header", Object.assign({ className: this.props.classes.root }, { children: this.props.children }), void 0));
    }
}
exports.IsolateHeader = IsolateHeader;
IsolateHeader.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired
};
exports.default = react_jss_1.default(isolate_header_style_1.default)(IsolateHeader);
//# sourceMappingURL=isolate.header.js.map